<template>
    <AuthStepBasicDialog>

        <template #icon>
            <CheckIcon></CheckIcon>
        </template>


        <template #title>
            All Done!
        </template>


        <template #description>
            Your password has been reset
        </template>


        <template #form>
            <button class="  button--primary rounded-pill text-15 weight-600 py-4 px-16"
                @click="goBackToLogin">
                Sign In
            </button>
        </template>

    </AuthStepBasicDialog>
</template>



<script setup lang="ts">

import authEvents from '@/Events/AuthDialog';
import forgotPasswordEvents from '@/Events/ForgotPassword';
import CheckIcon from '@/icons/ResetPassword/Check.vue';
import { provide, ref, onMounted, onUnmounted } from 'vue';
import AuthStepBasicDialog from '@/components/Auth/Common/Auth-Steps-Basic-Dialog.vue';

const dialogVisible = ref(false);
provide('openDialog', dialogVisible)


const passwordResetSuccessful = () => {
    dialogVisible.value = true;
}


const closeDialog = () => {
    dialogVisible.value = false;
}


const goBackToLogin = () => {
    authEvents.emit('open-auth-dialog');
    closeDialog();
};


onMounted(() => {
    forgotPasswordEvents.on('forgot-password-password-reset-successfull', passwordResetSuccessful);
});

onUnmounted(() => {
    forgotPasswordEvents.off('forgot-password-password-reset-successfull', passwordResetSuccessful);
});

</script>